import CustomInput from './customInput';

export default CustomInput;